<!-- Zweck: Stellt die HTML-Struktur für app customer settings component im Frontend bereit. -->
<section-title [hasBack]="true" [label]="'Kunden-Einstellungen'" icon="einstellungen"></section-title>

<div class="paddedcontent">
  <div class="mat-elevation-z2 settingsbox">
    <settings-box [settings]="settings" [(saveReady)]="saveReady" [(value)]="value" [settings_if_parent]="this"
    (settingsLoaded)="loadReady = $event"></settings-box>

    @if (!loadReady) {
      <div style="text-align: center; padding: 20px">
        <div style="display: inline-block">
          <mat-spinner></mat-spinner>
          <h3 style="margin-top: 20px">Lade...</h3>
        </div>
      </div>
    }
  </div>

  @if (loadReady) {
    <div style="text-align: center; margin-top: 10px">
      <button (click)="save()" [disabled]="!saveReady" mat-flat-button>
        <svg-icon>speichern</svg-icon>
        Speichern
      </button>
    </div>
  }
</div>
